import { useMemo, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { PieChart } from "@mui/x-charts/PieChart";
import { useMediaQuery } from "@mui/material";
export default function MortgageCalculator() {
  // ---------------- STATE ----------------
  const [propertyPrice, setPropertyPrice] = useState(1000000);
  const [downPayment, setDownPayment] = useState(100000);
  const [interestRate, setInterestRate] = useState(5);
  const [years, setYears] = useState(7);
  const [isMobiles, setIsMobile] = useState(false);
  const isMobile = useMediaQuery("(max-width:576px)");
  // ---------------- CALCULATION (LIVE) ----------------
  const result = useMemo(() => {
    const principal = propertyPrice - downPayment;
    const monthlyRate = interestRate / 100 / 12;
    const months = years * 12;

    const emi =
      (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);

    const totalInterest = emi * months - principal;

    return {
      principal,
      downPayment,
      interest: totalInterest,
      emi,
    };
  }, [propertyPrice, downPayment, interestRate, years]);

  const total = result.principal + result.downPayment + result.interest;
  useEffect(() => {
    setIsMobile(window.innerWidth < 576);
  }, []);

  // ---------------- UI ----------------
  return (
    <>
    
<style>
  {
    `
    .small-input
    {
       height: 30px;
    min-height: 20px;
    width: 25%;
     border:none;
     border-bottom:1px solid gray;
     border-radius:0px;
     padding:6px 4px 6px ;

    }
    .amount-enter-wrap
    {
    display:flex;
    justify-content:end;
    }
    `
  }
</style>
      <Container className="my-5">
        <Row className="g-4">
          {/* ================= LEFT : FORM ================= */}
          <Col md={6}>
            <div className="p-4 border rounded bg-white h-100">
              <h4 className="mb-4">Mortgage Calculator</h4>

              <label className="form-label">Property Price</label>
              <input
                type="text"
                className="form-control mb-3"
                value={propertyPrice}
                onChange={(e) => setPropertyPrice(Number(e.target.value))}
              />

              <label className="form-label d-flex justify-content-between align-items-center">
                  Down Payment 
                  (Rs {downPayment.toLocaleString()})
                  <div className="text-dark amount-enter-wrap d-flex align-items-center">
                  <span className="text-dark">
                    Enter Amount:
                  </span>
                  <input
                  type="text"
                  className="form-control small-input"
                  value={downPayment}
                   onChange={(e) => setDownPayment(Number(e.target.value))}
                   placeholder="Enter "
                  />
                  </div>
                </label>
              <input
                type="range"
                className="form-range mb-3"
                min={0}
                max={propertyPrice}
                value={downPayment}
                onChange={(e) => setDownPayment(Number(e.target.value))}
              />
               {/* <input
                  type="text"
                  className="form-control mb-3"
                  value={downPayment}
                   onChange={(e) => setDownPayment(Number(e.target.value))}
                   placeholder="Enter "
                  /> */}

              <label className="form-label">
                Loan Duration ({years} Years)
              </label>
              <input
                type="range"
                className="form-range mb-3"
                min={1}
                max={30}
                value={years}
                onChange={(e) => setYears(Number(e.target.value))}
              />

              <label className="form-label">
                Interest Rate ({interestRate}%)
              </label>
              <input
                type="text"
                className="form-control mb-4"
                value={interestRate}
                onChange={(e) => setInterestRate(Number(e.target.value))}
              />

              <h6 className="text-muted">Monthly Repayment</h6>
              <h3 className="fw-bold">Rs {result.emi.toFixed(2)}</h3>
            </div>
          </Col>

          {/* ================= RIGHT : PIE ================= */}
          <Col md={6}>
            <div className="p-4 border rounded bg-white h-100">
              <h4 className="mb-3">Mortgage Payment</h4>

              {/* <PieChart
  height={isMobile ? 220 : 300}
  margin={{
    top: 10,
    bottom: isMobile ? 10 : 30,
    left: 10,
    right: 10,
  }}
  series={[
    {
      data: [
        { id: 0, value: result.principal, label: "Principal" },
        { id: 1, value: result.interest, label: "Interest" },
        { id: 2, value: result.downPayment, label: "Down Payment" },
      ],

      innerRadius: 0,

      // ✅ SHOW LABELS ONLY ON DESKTOP
      arcLabel: isMobile
        ? undefined
        : (item) =>
            `${item.label} ${(
              (item.value / total) *
              100
            ).toFixed(1)}%`,

      arcLabelMinAngle: isMobile ? 999 : 15,
    },
  ]}
  colors={["#7F7FC6", "#FF385C", "#27AE60"]}
  slotProps={{
    tooltip: {
      formatter: (item) =>
        `${item.label}: Rs ${item.value.toLocaleString()}`,
    },
    legend: {
      hidden: !isMobile, // legend only on mobile
      direction: "column",
      position: { vertical: "bottom", horizontal: "middle" },
    },
  }}
/> */}
              <PieChart
                height={isMobile ? 220 : 300}
                margin={{
                  top: 10,
                  bottom: isMobile ? 10 : 30,
                  left: 10,
                  right: 10,
                }}
                series={[
                  {
                    data: [
                      { id: 0, value: result.principal, label: "Principal" },
                      { id: 1, value: result.interest, label: "Interest" },
                      {
                        id: 2,
                        value: result.downPayment,
                        label: "Down Payment",
                      },
                    ],

                    innerRadius: 0,

                    // ✅ Completely remove labels (and color squares) on mobile
                    arcLabel: isMobile
                      ? undefined
                      : (item) => `${((item.value / total) * 100).toFixed(1)}%`,
                    // arcLabel:null,

                    arcLabelMinAngle: 15,
                  },
                ]}
                colors={["#7F7FC6", "#FF385C", "#27AE60"]}
                slotProps={{
                  legend: {
                    hidden: true, // no legend on mobile or desktop
                  },
                  tooltip: {
                    formatter: (item) =>
                      `${item.label}: Rs ${item.value.toLocaleString()}`,
                  },
                }}
              />

              {/* ===== SUMMARY BOXES ===== */}
              <div className="mt-4">
                <SummaryRow
                  color="#7F7FC6"
                  label="Principal"
                  value={result.principal}
                />
                <SummaryRow
                  color="#FF385C"
                  label="Interest"
                  value={result.interest}
                />
                <SummaryRow
                  color="#27AE60"
                  label="Down Payment"
                  value={result.downPayment}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <section className="note-section py-5">
        <Container>
          <Row>
            <Col md={12}>
              <h3>Have a check On this!</h3>
              <p>
                Bengaluru have increased due to the Karnataka government
                doubling registration fees from 1% to 2% as of August 31, 2025.
                This makes a fixed-fee model highly attractive to consumers
                looking to avoid traditional commissions (typically 2%–5%) that
                now add to an already higher tax burden.
              </p>
              <p>
                Buying property in Bengaluru requires careful due diligence,
                with specific documents and checks varying by property type.
                Below is a checklist for buyers, organized by property type.
              </p>
              <h5>Market Considerations for Bengaluru:</h5>
              <ul className="d-flex flex-column gap-2">
                <li>
                  <strong>Higher Total Acquisition Costs:</strong>
                  Total costs (Stamp Duty 5% + Registration 2% + Cess) now reach
                  roughly 7.6%. Position your fixed-fee model as a "Tax Offset"
                  to help buyers manage these rising costs.
                </li>
                <li>
                  <strong>Digitization Opportunities:</strong> Leverage the
                  Kaveri 2.0 Online Services and the new e-Khata system to
                  automate document retrieval, allowing you to keep fixed fees
                  low while maintaining margins.
                </li>
                <li>
                  <strong> Legal Compliance:</strong> Ensure your portal is RERA
                  Karnataka Registered. In 2025, transparency in fee disclosure
                  is a primary focus for regulators.
                </li>
                <li>
                  <strong>Target Mid-Premium Segments:</strong> Focusd fixed-fee
                  marketing on the ₹50 lakh – ₹1.5 crore segment, which is
                  currently the most active in Bengaluru. High-value luxury
                  properties (₹5 crore) may still require traditional
                  personalized high-touch service.
                </li>
              </ul>
              <p className="mt-5">
                <i>
                  <strong> Please note:</strong> Above contents and terms are
                  subject to change without prior notification
                </i>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

// ---------------- SUMMARY ROW ----------------
function SummaryRow({ color, label, value }) {
  return (
    <div className="d-flex justify-content-between align-items-center border rounded p-3 mb-2">
      <div className="d-flex align-items-center gap-2">
        <span
          style={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
          }}
        />
        <strong>{label}</strong>
      </div>
      <strong>Rs {value.toLocaleString()}</strong>
    </div>
  );
}
